// extracted by mini-css-extract-plugin
export var attachmentContainer = "_n0-0";
export var fileList = "_n0-2";
export var removeFileButton = "_n0-1";